<template>
  <v-data-table
    v-bind="dataTableAttrs"
    :headers="headersShown"
    :items="list"
    :loading="isLoading"
    :options.sync="options"
    :server-items-length="total"
    :items-per-page.sync="itemsPerPage"
    v-model="selectedItems"
    @update:items-per-page="handleItemsPerPageUpdated"
    :show-select="false"
  >
    <template v-slot:top>
      <rs-table-title-bar
        class="mt-6"
        v-if="$refs.headSearch"
        title=""
        icon=""
        @clear-filters="$refs.headSearch.reset"
        @reload="loadList"
        :search.sync="search.query"
        hide-edit
      />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:body.prepend="{ headers }">
      <rs-table-head-search
        :headers="headers"
        :search.sync="search"
        ref="headSearch"
      />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.is_active="{ value }">
      <rs-table-cell-boolean :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.payment_count="{ item }">
      <router-link
        v-if="item.payment_count"
        :to="{
          name: 'activities.cc-payments.list',
          query: {
            user_card_id: item.id,
          },
        }"
      >
        {{ item.payment_count }}
      </router-link>
      <span v-else>0</span>
    </template>
  </v-data-table>
</template>

<script>
import { debounce } from "@/core/plugins/debounce";
import { hasDataTable } from "@/view/mixins";
import { mapGetters } from "vuex";

export default {
  name: "AdminUserCardList",
  mixins: [hasDataTable],
  props: {
    userId: {
      type: Number,
      required: false,
    },
  },
  watch: {
    userId() {
      this.loadList();
    },
    search: {
      handler: debounce(function () {
        this.loadList();
      }),
      deep: true,
    },
    options: {
      handler() {
        this.loadList();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["paymentProviderList"]),
  },
  data() {
    return {
      options: {
        sortBy: ["created_at"],
        sortDesc: [true],
      },
      headers: [
        {
          text: "Ödeme Tedarikçisi",
          value: "payment_provider_name",
          searchable: "multiselect",
          searchValue: "payment_provider_ids",
          options: () => this.paymentProviderList,
        },
        {
          text: "KK No",
          value: "masked_cc_no",
          searchable: "text",
        },
        {
          text: "İsim",
          value: "name",
          searchable: "text",
        },
        {
          text: "SKT",
          value: "expires_on",
          searchable: "text",
          align: "end",
        },
        {
          text: "Durum",
          value: "is_active",
          searchable: "isActive",
          align: "center",
          width: "40px",
        },
        {
          text: "Ödeme",
          value: "payment_count",
          searchable: "number",
          align: "end",
          notPrice: true,
        },
        {
          text: "Talimat",
          value: "subscription_count",
          searchable: "number",
          align: "end",
          notPrice: true,
        },
        {
          text: "Hesap Kesim",
          value: "settle_day",
          searchable: "number",
          align: "end",
        },
        {
          text: "Oluşturma",
          value: "created_at",
          searchable: "date",
        },
      ],
    };
  },
  methods: {
    loadList() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.list = [];

      const params = Object.assign(
        this.buildSearchParams(this.search, this.options)
      );

      if (this.userId) {
        params.user_id = this.userId;
      }

      return this.$api
        .query("api-super-admin/user-cards", {
          params,
        })
        .then((response) => {
          this.loadListFromResponse(response);
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => (this.isLoading = false));
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.loadList();
    });
  },
};
</script>
